import React from 'react';
import { useRecoilValue } from 'recoil';

import { onboardingTestIDs } from '@constants';
import { screenReaderEnabledState } from '@store';

import { DeviceActivationContent } from './components/DeviceActivationContent';

import { TWCPage } from '../../components/primitives/TWCPage/TWCPage';

export const DeviceActivationPage = () => {
  const screenReaderEnabled = useRecoilValue(screenReaderEnabledState);

  return (
    <TWCPage
      childIds={[
        onboardingTestIDs.deviceActivation.focusTrap,
        onboardingTestIDs.deviceActivation.firstStepSection,
        onboardingTestIDs.deviceActivation.secondStepSection,
        onboardingTestIDs.deviceActivation.thirdStepSection,
      ]}
      firstFocus={
        screenReaderEnabled
          ? onboardingTestIDs.deviceActivation.firstStepSection
          : onboardingTestIDs.deviceActivation.focusTrap
      }
      hasBackground={false}
      pageID={onboardingTestIDs.pages.deviceActivationPage}
    >
      <DeviceActivationContent.API />
    </TWCPage>
  );
};
